import { Col, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";

const ViewBinMasterModal = (props) => {

    const getSinleBinMasterData = props.getSinleBinMasterData;
    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Bin Master</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Bin Code</label>
                                        <span>{getSinleBinMasterData[0]?.BinCode}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Bar Code ID </label>
                                        <span>{getSinleBinMasterData[0]?.BarCodeID}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Length</label>
                                        <span>{getSinleBinMasterData[0]?.Length}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Width</label>
                                        <span>{getSinleBinMasterData[0]?.Width}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Height</label>
                                        <span>{getSinleBinMasterData[0]?.Height}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Volume</label>
                                        <span>{getSinleBinMasterData[0]?.Volume}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Dimension</label>
                                        <span className="description-text">{getSinleBinMasterData[0]?.Dimension}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Unit</label>
                                        <span>{getSinleBinMasterData[0]?.UOMCode}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Plant</label>
                                        <span>{getSinleBinMasterData[0]?.PlantName}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="view-sla-data">
                                        <label>Sloc</label>
                                        <span className="description-text">{getSinleBinMasterData[0]?.SlocName}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Zone Name </label>
                                        <span>{getSinleBinMasterData[0]?.ZoneName || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Storage Type Code</label>
                                        <span>{getSinleBinMasterData[0]?.StorageTypeCode || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className='add-customer-calendar-container view-sla-data'>
                                        <label>Level</label>
                                        <span>{getSinleBinMasterData[0]?.BinLevel || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Rack Code</label>
                                        <span>{getSinleBinMasterData[0]?.RackCode || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Rack Lane</label>
                                        <span>{getSinleBinMasterData[0]?.RackLane || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Sequence</label>
                                        <span className="description-text">{getSinleBinMasterData[0]?.Sequence || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Weight</label>
                                        <span className="description-text">{getSinleBinMasterData[0]?.Weight || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Weight UOM</label>
                                        <span className="description-text">{getSinleBinMasterData[0]?.WeightUOM || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Status</label>
                                        <span className="description-text">{getSinleBinMasterData[0]?.Status || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewBinMasterModal;